const getInitialState = () => ({
	sequenceId: null,
	sequence: {},
	emailId: null,
	email: {},
	generalErrors: []
});

export default getInitialState;
